import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import classes from '@nerdwallet/base-styles/classes';

import { Title, Text, Box, CenteredContainer } from '@nerdwallet/currency';
import SmartButton from '../smart-button/smart-button';

import parseMarkdownLinks from '../../lib/parse-md-links';

import {
  stringTextAreaSpec,
  stringInputSpec,
  stringSelectSpec,
} from '../../lib/editing-configs';

import './cta-box.less';

const titleSizeEnum = {
  5: 'default',
  4: 'large',
  3: 'large',
  2: 'small',
  1: 'default',
};

const CtaBox = ({
  title,
  body,
  iconUri,

  // For the button
  buttonType,
  buttonText,
  buttonURL,
  buttonParams,
  headingStyle,
  successURL,
  authDialogCopyOverrides,
  authDialogImageOverrides,
  appStoreURL,
  googlePlayURL,
  ...smartButtonProps
}) => {
  let TitleComponent = Text;
  if (headingStyle === '1' || headingStyle === '2') {
    TitleComponent = Title;
  }
  const iconBgImage = iconUri && `url(${iconUri})`;

  return (
    <CenteredContainer>
      <Box
        className={classNames([
          'cta-box',
          {
            [classes('padding-right-3--wide')]: iconUri,
            [classes('padding-left-0--wide')]: iconUri,
          },
        ])}
      >
        {iconUri && (
          <Box
            className={classNames([
              classes('display-none'),
              classes('display-block--wide'),
              'cta-box__icon',
            ])}
            style={{ backgroundImage: iconBgImage }}
          />
        )}
        <Box className="cta-box__text">
          <Box className="cta-box__title">
            <TitleComponent size={titleSizeEnum[headingStyle]}>
              {title}
            </TitleComponent>
          </Box>
          <Box className={classes('padding-vertical-2')}>
            <Text>{parseMarkdownLinks(body)}</Text>
          </Box>
        </Box>
        {buttonType && (
          <Box className="cta-box__cta">
            <Box className={classes('display-none--wide')}>
              <SmartButton
                buttonText={`${buttonText} >`}
                buttonURL={buttonURL}
                buttonType={buttonType}
                buttonParams={buttonParams}
                successURL={successURL}
                authDialogCopyOverrides={authDialogCopyOverrides}
                authDialogImageOverrides={authDialogImageOverrides}
                appStoreURL={appStoreURL}
                googlePlayURL={googlePlayURL}
                link
                {...smartButtonProps}
              />
            </Box>
            <Box
              className={classes(
                'display-none',
                'display-block--wide',
                'margin-horizontal-3'
              )}
            >
              <SmartButton
                buttonText={buttonText}
                buttonURL={buttonURL}
                buttonType={buttonType}
                buttonParams={buttonParams}
                appStoreURL={appStoreURL}
                googlePlayURL={googlePlayURL}
                {...smartButtonProps}
              />
            </Box>
          </Box>
        )}
      </Box>
    </CenteredContainer>
  );
};

CtaBox.propTypes = {
  headingStyle: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  iconUri: PropTypes.string,
  ...SmartButton.propTypes,
};

CtaBox.defaultProps = {
  headingStyle: '3',
};

CtaBox.displayName = 'CtaBox';

CtaBox.getEditingConfig = (componentDocument) => [
  stringTextAreaSpec('title', 'Title'),
  stringSelectSpec('headingStyle', 'Heading Style', [
    { label: 'Select one', value: '' },
    { label: 'Heading 1', value: '1' },
    { label: 'Heading 2', value: '2' },
    { label: 'Heading 3', value: '3' },
    { label: 'Heading 4', value: '4' },
    { label: 'Heading 5', value: '5' },
  ]),
  stringTextAreaSpec('body', 'Body', {
    help: `Want a hyperlink? Write it like this: [Hi!](https://www.thing.com).
           NW links should be relative, e.g., [Home](/home)`,
  }),
  stringInputSpec('iconUri', 'Icon URL'),
  ...SmartButton.getEditingConfig(componentDocument),
];

export default CtaBox;
